import { render } from "./CostingRates.vue?vue&type=template&id=69d556d3"
import script from "./CostingRates.vue?vue&type=script&lang=js"
export * from "./CostingRates.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__